import React from 'react'
import Modal from '../Modal'
import UpgradePlanBody from './UpgradePlanBody'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import styles from './UpgradePlanModal.module.scss'

const UpgradePlanModal = () => {
  const { themeMode } = useTheme() || {}
  return (
    <Modal
      className={styles.modal}
      // Inline because it has to win over the shared `.modal` class, which is
      // applied to the dialog and its body alike. Fluid below 970 so a phone
      // gets the screen width minus a gutter instead of a fixed 970 that
      // overflows and clips the right-hand pricing card.
      style={{ maxWidth: 'min(970px, calc(100vw - 24px))' }}
      id='upgradeYourPlan'
      themeMode={themeMode}
      modalCoverStyle={{ zIndex: 9999 }}
      hasCloseButton={false}
      shouldCloseOnOverlayClick={false}
      // `maxHeight` is deliberately not unset any more: the stylesheet's mobile
      // cap is what lets the body scroll rather than overflow the screen.
      bodyStyle={{ margin: '0', maxWidth: 'unset', width: '100%' }}
    >
      {({ modalData }) => {
        let type = 'pro'
        let closable = true
        let onFreeButtonClicked = () => {}
        let handleOnClose = null
        let withFreeOption = false
        // Without these two the modal has no channel for a call site to say
        // *why* it opened, so every modal impression was recorded as
        // paywall_type 'feature' and 'limit' was unreachable outside the
        // full-page LimitExceeded screen. `modalData` is still accepted as a
        // bare plan string -- most of the ~80 call sites pass one.
        let paywallType
        let surface
        let featureName
        let trigger
        let agent
        let model
        let targetPath
        let vars
        if (modalData && typeof modalData === 'object') {
          type = modalData.type
          closable = modalData.closable
          onFreeButtonClicked = modalData.onFreeButtonClicked || (() => {})
          handleOnClose = modalData.handleOnClose
          withFreeOption = modalData.withFreeOption
          paywallType = modalData.paywallType
          surface = modalData.surface
          featureName = modalData.featureName
          trigger = modalData.trigger
          agent = modalData.agent
          model = modalData.model
          targetPath = modalData.targetPath
          vars = modalData.vars
        } else {
          type = modalData
        }
        return (
          <UpgradePlanBody
            type={type} closable={closable} {...{
              handleOnClick: onFreeButtonClicked,
              handleOnClose: handleOnClose,
              withFreeOption: withFreeOption,
              // Undefined falls through to UpgradePlanBody's own defaults
              // ('feature' / 'upgrade_modal'); passing them explicitly as
              // undefined would not.
              ...(paywallType ? { paywallType } : {}),
              ...(surface ? { surface } : {}),
              ...(featureName ? { featureName } : {}),
              ...(trigger ? { trigger } : {}),
              ...(agent ? { agent } : {}),
              ...(model ? { model } : {}),
              ...(targetPath ? { targetPath } : {}),
              ...(vars ? { vars } : {})
            }}
          />
        )
      }}
    </Modal>
  )
}

export default UpgradePlanModal
